module.exports = __webpack_public_path__ + "static/media/8.bb72063a.jpg";